
export function getNombreFicheroSinExtension(nombreFichero: string): string |null {
    return (nombreFichero == null) ? null : nombreFichero.substring(0, nombreFichero.lastIndexOf('.'));
}